<div [loading]="loading">

  <div class="cart-page-wrapper">
    <div class="container">

      <gob-step-order [ind]="0"></gob-step-order>

      <div *ngIf="!cart.getLines().length" class="empty-cart">
        <div class="empty-content">
          <i class="fa-solid fa-basket-shopping"></i>
          <h2>Votre panier est vide</h2>
          <p>Il semblerait que vous n'ayez pas encore trouvé votre bonheur.</p>
          <a routerLink="/" class="btn-continue">Retourner à la boutique</a>
        </div>
      </div>

      <div *ngIf="cart.getLines().length">
        
        <div class="msg-container">
          <gob-message [error]="error"></gob-message>
        </div>

        <div class="cart-grid">

          <div class="cart-main">
            
            <div class="cart-header desktop-only">
              <h1>Mon Panier</h1>
              <span class="count">{{cart.getLines().length}} article{{cart.getLines().length > 1 ? 's' : ''}}</span>
            </div>

            <div class="stock-alert">
              <i class="fa-solid fa-truck-fast"></i>
              <span>
                {{ getAvailability() === 0 
                  ? 'Tous les produits sont en stock. Expédition immédiate.' 
                  : 'Votre commande contient des précommandes. Elle sera expédiée en une seule fois.' }}
              </span>
            </div>

            <div class="cart-table desktop-only">
              <div class="cart-row header">
                <div class="col-product">Produit</div>
                <div class="col-qty">Quantité</div>
                <div class="col-total">Total</div>
                <div class="col-action"></div>
              </div>

              <div class="cart-row item" *ngFor="let line of cart.getLines(); index as i">
                <div class="col-product">
                  <div class="product-wrapper">
                    <div class="img-box">
                      <img [src]="getImage(line.product)" [alt]="line.product.name">
                    </div>
                    <div class="details">
                      <a [routerLink]="['/product', line.product.ident]" class="name">{{ line.product.name }}</a>
                      <div class="unit-price">{{ line.price.prix | formatPrice }}€ <span class="unit">/ unité</span></div>
                      
                      <div class="availability" *ngIf="isFutureRelease(line.product.releaseDate); else inStock">
                        <span class="tag preorder">Précommande</span>
                        <small>Sortie le {{ line.product.releaseDate | date:'dd/MM/yyyy':'':'fr-FR' }}</small>
                      </div>
                      <ng-template #inStock>
                        <div class="availability"><span class="tag instock">En stock</span></div>
                      </ng-template>
                    </div>
                  </div>
                  
                  <div class="gift-option">
                    <label class="custom-checkbox">
                      <input type="checkbox" (change)="setGift(line, $event)" [checked]="line.giftWrapping === 1">
                      <span class="checkmark"></span>
                      <span class="label-text"><i class="fa-solid fa-gift"></i> Emballage cadeau (+1,50€) <small *ngIf="line.qte > 1">* offert dès 2 ex.</small></span>
                    </label>
                  </div>
                </div>

                <div class="col-qty">
                  <div class="qty-selector">
                    <button (click)="decreaseQuantity(line)">-</button>
                    <input type="text" [value]="line.qte" readonly>
                    <button (click)="increaseQuantity(line)">+</button>
                  </div>
                  <div class="limit-msg" *ngIf="line.maxReached">Max atteint</div>
                </div>

                <div class="col-total">
                  <span class="price">{{ (line.qte * line.price.prix) | formatPrice }}€</span>
                </div>

                <div class="col-action">
                  <button class="btn-delete" (click)="cart.rm(i)" title="Supprimer">
                    <i class="fa-solid fa-trash-can"></i>
                  </button>
                </div>
              </div>
            </div>

            <div class="cart-mobile-list mobile-only">
              <div class="mobile-card" *ngFor="let line of cart.getLines(); index as i">
                <div class="card-top">
                  <div class="img-box">
                    <img [src]="getImage(line.product)" [alt]="line.product.name">
                  </div>
                  <div class="card-info">
                    <div class="name">{{ line.product.name }}</div>
                    <div class="unit-price">{{ line.price.prix | formatPrice }}€</div>
                    <div class="availability" *ngIf="isFutureRelease(line.product.releaseDate)">
                      <small class="preorder-text">Sortie : {{ line.product.releaseDate | date:'dd/MM/yyyy':'':'fr-FR' }}</small>
                    </div>
                  </div>
                  <button class="btn-delete-mobile" (click)="cart.rm(i)"><i class="fa-solid fa-xmark"></i></button>
                </div>
                
                <div class="card-bottom">
                  <div class="qty-selector small">
                    <button (click)="decreaseQuantity(line)">-</button>
                    <input type="text" [value]="line.qte" readonly>
                    <button (click)="increaseQuantity(line)">+</button>
                  </div>
                  <div class="row-total">
                    {{ (line.qte * line.price.prix) | formatPrice }}€
                  </div>
                </div>
                
                <div class="gift-mobile">
                   <label>
                      <input type="checkbox" (change)="setGift(line, $event)" [checked]="line.giftWrapping === 1"> 
                      Emballage cadeau (+1,50€)
                   </label>
                </div>
              </div>
            </div>

          </div>

          <div class="cart-sidebar">
            <div class="summary-card">
              <h3>Résumé de la commande</h3>
              
              <div class="promo-code-area">
                <label>Code promotionnel</label>
                <div class="input-group">
                  <input type="text" placeholder="Entrez votre code" [formControl]="discountControl">
                  <span class="icon"><i class="fa-solid fa-tag"></i></span>
                </div>
              </div>

              <div class="summary-lines" [class.has-extras]="discount || getGiftWrappingAmount() > 0">
                <div class="summary-row" *ngIf="discount">
                  <span>Réduction</span>
                  <span class="val discount">-{{ getDiscount() | formatPrice }}€</span>
                </div>
                <div class="summary-row" *ngIf="getGiftWrappingAmount() > 0">
                  <span>Emballages cadeaux</span>
                  <span class="val">{{ getGiftWrappingAmount() | formatPrice }}€</span>
                </div>
                <div class="summary-row total">
                  <span>Total TTC</span>
                  <span class="val">{{ getTotal() }}€</span>
                </div>
                <p class="shipping-note">Frais de port calculés à l'étape suivante</p>
              </div>

              <button class="btn-checkout" (click)="next()">
                Valider mon panier
                <i class="fa-solid fa-arrow-right"></i>
              </button>

              <div class="reassurance">
                <div><i class="fa-solid fa-lock"></i> Paiement 100% sécurisé</div>
                <div><i class="fa-solid fa-truck-fast"></i> Expédition soignée</div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>